(function () {
  document.querySelectorAll('.hbl-mb').forEach(function (root) {
    var money = root.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
    var pct = parseInt(root.getAttribute('data-pct'), 10) || 0;
    var code = root.getAttribute('data-code') || '';
    var afterTxt = root.getAttribute('data-after') || '';
    function fmt(c) { return money.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2).replace('.', ',')); }

    var chip = root.querySelector('[data-mb-copy]');
    if (chip) chip.addEventListener('click', function () {
      var lbl = chip.querySelector('[data-mb-copied]');
      var done = function () { lbl.textContent = 'Copié ✓'; setTimeout(function () { lbl.textContent = 'Copier'; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(chip.getAttribute('data-mb-copy')).then(done, done); else done();
    });

    var row = root.querySelector('[data-mb-row]');
    function slide(d) { if (!row) return; var card = row.querySelector('.hbl-mb__card'); var w = card ? card.getBoundingClientRect().width + 18 : 300; row.scrollBy({ left: d * w, behavior: 'smooth' }); }
    var pv = root.querySelector('[data-mb-prev]'), nx = root.querySelector('[data-mb-next]');
    if (pv) pv.addEventListener('click', function () { slide(-1); });
    if (nx) nx.addEventListener('click', function () { slide(1); });

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var els = root.querySelectorAll('.hbl-mb__look, .hbl-mb__card');
      root.classList.add('js-ready');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var i = Array.prototype.indexOf.call(els, e.target); e.target.style.transitionDelay = (Math.min(i, 6) * 70) + 'ms'; e.target.classList.add('is-in'); io.unobserve(e.target); }); }, { threshold: 0.1 });
      els.forEach(function (el) { io.observe(el); });
      setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 3000);
    }

    /* Vitrine qui tourne (ordinateur) */
    (function () {
      if (!row || !window.matchMedia('(min-width: 990px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var cards = Array.prototype.slice.call(row.querySelectorAll('.hbl-mb__card'));
      var N = 5;
      if (cards.length <= N) return;
      var shown = cards.slice(0, N), pool = cards.slice(N);
      root.classList.add('is-rot');
      shown.forEach(function (c, i) { c.style.order = i; });
      pool.forEach(function (c) { c.classList.add('is-off-rot'); });
      var seq = [1, 3, 0, 4, 2], k = 0, paused = false;
      row.addEventListener('mouseenter', function () { paused = true; });
      row.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        var slot = seq[k++ % seq.length];
        var out = shown[slot], inc = pool.shift();
        out.style.transitionDelay = '0ms';
        out.classList.add('is-fading');
        setTimeout(function () {
          out.classList.add('is-off-rot'); out.classList.remove('is-fading'); out.style.order = '';
          inc.style.order = slot; inc.style.transitionDelay = '0ms';
          inc.classList.add('is-fading', 'is-in'); inc.classList.remove('is-off-rot');
          void inc.offsetWidth;
          inc.classList.remove('is-fading');
          shown[slot] = inc; pool.push(out);
        }, 450);
      }, 3500);
    })();

    var look = root.querySelector('[data-mb-look]');
    if (!look) return;
    var items = look.querySelectorAll('[data-mb-item]');
    var totalEl = look.querySelector('[data-mb-total]'), afterEl = look.querySelector('[data-mb-after]'), note = look.querySelector('[data-mb-note]'), btn = look.querySelector('[data-mb-add]');
    function total() {
      var t = 0;
      items.forEach(function (it) {
        var inc = it.querySelector('[data-mb-inc]').checked;
        it.classList.toggle('is-off', !inc);
        if (!inc) return;
        var sel = it.querySelector('[data-mb-var]'), p = parseInt(it.getAttribute('data-price'), 10);
        if (sel.tagName === 'SELECT' && sel.value) { p = parseInt(sel.options[sel.selectedIndex].getAttribute('data-p'), 10) || p; }
        else if (sel.tagName === 'INPUT') { p = parseInt(sel.getAttribute('data-p'), 10) || p; }
        t += p;
      });
      totalEl.textContent = fmt(t);
      if (afterEl) afterEl.textContent = t > 0 ? 'soit ' + fmt(Math.round(t * (100 - pct) / 100)) + ' ' + afterTxt : '';
      note.textContent = '';
    }
    items.forEach(function (it) {
      it.querySelector('[data-mb-inc]').addEventListener('change', total);
      var s = it.querySelector('select[data-mb-var]');
      if (s) s.addEventListener('change', function () { s.classList.remove('is-missing'); total(); });
    });
    total();
    btn.addEventListener('click', function () {
      var list = [], missing = null;
      items.forEach(function (it) {
        if (!it.querySelector('[data-mb-inc]').checked) return;
        var sel = it.querySelector('[data-mb-var]');
        if (!sel.value) { sel.classList.add('is-missing'); if (!missing) missing = sel; return; }
        list.push({ id: parseInt(sel.value, 10), quantity: 1 });
      });
      if (missing) { note.textContent = 'Choisis ta taille pour chaque pièce.'; missing.focus(); return; }
      if (!list.length) { note.textContent = 'Coche au moins une pièce.'; return; }
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Ajout en cours…';
      var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var applyCode = code ? fetch(r + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      fetch(r + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
        .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.description || 'Oups, réessaie.'); return d; }); })
        .then(function () { return applyCode; })
        .then(function () { return fetch(r + 'cart.js').then(function (res) { return res.json(); }); })
        .then(function (cart) {
          btn.textContent = 'Ajoutée ✓';
          note.textContent = code ? 'Ta tenue est dans le panier, le code ' + code + ' est activé.' : 'Ta tenue est dans le panier.';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'hbl-marron', data: { itemCount: cart.item_count, source: 'hbl-marron' } } }));
          setTimeout(function () { var d = document.querySelector('cart-drawer-component'); if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} } }, 350);
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
        })
        .catch(function (err) { btn.textContent = label; btn.disabled = false; note.textContent = err.message; });
    });
  });
})();